declare global {
  interface Window {
    _paq: Array<[string, ...(string | number)[]]>
    _mtm: object[]
    MatomoConsent: { consentGiven: () => void; consentRevoked(): void }
  }
}

export class Matomo {
  public static init() {
    if (typeof window === 'undefined') {
      return
    }

    window.MatomoConsent.consentGiven()
    const _mtm = (window._mtm = window._mtm || [])
    _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' })
    ;(function () {
      const d = document,
        g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0]
      g.async = true
      g.src = 'https://stats.interfleet.ch/js/container_to0FcYzu.js'
      s.parentNode?.insertBefore(g, s)
    })()
  }

  public static setUserId(userId: string) {
    if (!window._paq || !window._paq.push) {
      window._paq = []
    }
    window._paq.push(['setUserId', userId])
  }

  public static pushEvent(category: string, action: string, label: string, value: string | number) {
    if (!window._paq || !window._paq.push) {
      window._paq = []
    }
    window._paq.push(['trackEvent', category, action, label, value])
  }
}
